import { useEffect, useState, useContext, useRef, RefObject } from 'react';
import { FromFille } from './DeclarationSource/FromFille';
import { FromMemory } from './DeclarationSource/FromMemory';
import { New } from './DeclarationSource/New';
import MainContext from '../_helpers/Contexts/mainContext';
import SelectBox from 'devextreme-react/select-box';
import { FromFilleXML } from './DeclarationSource/FromFilleXML';

const DeclarationHome = () => {
    const [fromMemoryVisible, setFromMeomoryVisible] = useState(false);
    const { step, setStep } = useContext(MainContext);

    useEffect(() => {
        const step1 = localStorage.getItem('step1');
        if (!step1) {
            setFromMeomoryVisible(false);
        } else {
            setFromMeomoryVisible(true);
        }
    }, []);

    useEffect(() => {
        document.getElementById('ProgressBar')?.removeEventListener('click', function () {});
        if (setStep) setStep('step0');
    }, []);

    const mainRef = useRef<any>(null);

    useEffect(() => {
        if (mainRef.current) mainRef.current.focus();
    }, [mainRef]);

    return (
        <>
            <div className="container options">
                <div className="h1 mainHeaderTitle mb-5">Kalkulator deklaracji - odpady komunalne</div>
                <New />
                <FromFille />
                {/* <FromFilleXML /> */}
                {fromMemoryVisible && <FromMemory />}
            </div>
        </>
    );
};

export { DeclarationHome };
